import React from 'react';
import PaymentTrackingPage from '../shared/PaymentTrackingPage';

const PaymentInfo = () => (
  <PaymentTrackingPage
    title="Payment Info"
    subtitle="View payment details from all companies and department heads."
  />
);

export default PaymentInfo;
